import { API } from "@/utils/http"

export default {
  async sellerRating() {
    const response = await API.get("/v2/seller/dashboards/rating")

    return response
  },

  async ordersCondition() {
    const response = await API.get("/v2/seller/dashboards/orders-condition")

    return response
  },

  async offersCondition() {
    const response = await API.get("/v2/seller/dashboards/offer-conditions")

    return response
  },

  async ordersProsessingSpeed() {
    const response = await API.get("/v2/seller/dashboards/orders-processing")

    return response
  },

  async bestsellersList(params = {}) {
    const response = await API.get("/v2/seller/dashboards/top-sales", { params })

    return response
  },

  async bestsellersChart(params = {}) {
    const response = await API.get("/v2/seller/dashboards/sales-statistic", { params })

    return response
  },

  async fetchBillingStatusAndBalance() {
    const response = await API.get("/v2/seller/billing/dashboard")

    return response
  },

  async sellerBalance() {
    const response = await API.get("/v2/seller/billing/balance")

    return response
  },

  async replenishByBonuses(amount) {
    const response = await API.post("/v2/seller/billing/replenishments/by-owner-bonuses", {
      amount
    })

    return response
  }
}
